export const GET_WALLET_DATA_START = 'wallet/GET_WALLET_DATA_START';
export const GET_WALLET_DATA_COMPLETED = 'wallet/GET_WALLET_DATA_COMPLETED';
export const GET_WALLET_DATA_FAILED = 'wallet/GET_WALLET_DATA_FAILED';

export const REQUEST_WITHDRAWAL_START = 'wallet/REQUEST_WITHDRAWAL_START';
export const REQUEST_WITHDRAWAL_COMPLETED = 'wallet/REQUEST_WITHDRAWAL_COMPLETED';
export const REQUEST_WITHDRAWAL_FAILED = 'wallet/REQUEST_WITHDRAWAL_FAILED';

export const UPDATE_PAYOUT_SETTINGS_START = 'wallet/UPDATE_PAYOUT_SETTINGS_START';
export const UPDATE_PAYOUT_SETTINGS_COMPLETED = 'wallet/UPDATE_PAYOUT_SETTINGS_COMPLETED';
export const UPDATE_PAYOUT_SETTINGS_FAILED = 'wallet/UPDATE_PAYOUT_SETTINGS_FAILED';

export const SET_ACTIVE_TAB = 'wallet/SET_ACTIVE_TAB';

export const CONNECT_STRIPE_START = 'wallet/CONNECT_STRIPE_START';
export const CONNECT_STRIPE_COMPLETED = 'wallet/CONNECT_STRIPE_COMPLETED';
export const CONNECT_STRIPE_FAILED = 'wallet/CONNECT_STRIPE_FAILED';

export const LINK_BANK_ACCOUNT_START = 'wallet/LINK_BANK_ACCOUNT_START';
export const LINK_BANK_ACCOUNT_COMPLETED = 'wallet/LINK_BANK_ACCOUNT_COMPLETED';
export const LINK_BANK_ACCOUNT_FAILED = 'wallet/LINK_BANK_ACCOUNT_FAILED';
